export default __webpack_public_path__ + "static/bundle-dc569275124965823c093d1c1df0d07d.png";